<template>
  <div>
    <UiButton
      v-if="subscriptionHasAdvancedAnalytics"
      :theme="showLimitedView ? 'primary' : 'secondary'"
      size="sm"
      :label="showLimitedView ? 'Advanced' : 'Basic'"
      @button-click="toggleAnalyticsView"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue';
const UiButton = defineAsyncComponent(() => import('@/components/ui/UiButton.vue'));
import { useFeaturesStore } from '@/store/features.store';
import { useApplicationStore } from '@/store/application.store';

defineProps({
  componentClass: {
    type: String,
    default: ''
  }
});

const featuresStore = useFeaturesStore();
const applicationStore = useApplicationStore();

const subscriptionHasAdvancedAnalytics = computed(() => featuresStore.subscriptionHasFeature('advanced_analytics'));

// Use applicationStore to share the toggle state across header and view
const showLimitedView = computed({
  get: () => applicationStore.analyticsShowLimitedView ?? false,
  set: (value: boolean) => applicationStore.setState({ key: 'analyticsShowLimitedView', value })
});

function toggleAnalyticsView() {
  showLimitedView.value = !showLimitedView.value;
  // Reset to first tab when switching views
  applicationStore.setState({ key: 'currentTab', value: 0 });
}
</script>

